import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './booking-links-manager-skeleton.scss';

const CARD_COUNT: number = 6;

// Mirrors the real layout: one property-card grid, each card a title + two kind rows.
const BookingLinksManagerSkeleton = () => (
  <div className="booking-links-skeleton" aria-hidden>
    <div className="skeleton-grid">
      {Array.from({ length: CARD_COUNT }, (_, cardIndex: number) => (
        <Skeleton
          key={`bl-skeleton-card-${cardIndex}`}
          variant="rect"
          width="100%"
          height="11rem"
        />
      ))}
    </div>
  </div>
);

export default BookingLinksManagerSkeleton;